import Home from '../../app/pages/Home'
import authentication from '../authentication'
// import carPlate from './carPlate'
import dashboard from './dashboard'
// import requestFile from './requestFile'
// import activation from '../pageActivation'

export default [
  {
    exact: true,
    path: '/',
    component: Home
  },
  authentication,
  dashboard
]



// WEBPACK FOOTER //
// ./src/routes/profileActivation/index.js